/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import { ColorAliases } from 'styles/variables';
import { Sizes } from 'styles/variables-slykit';
import { useFacetsState } from 'hooks/useFacetsState';

export const EmptyFacetsMessage = ({ ...props }) => {
	const { getTextFilter } = useFacetsState();
	const filter = getTextFilter();
	return (
		<div {...props} css={messageStyles}>
			no results for "{filter}"
		</div>
	);
};
const messageStyles = css`
	color: ${ColorAliases.PT_TEXT_COLOR_DISABLED};
	font-style: italic;
	margin: 0 ${Sizes.lg};
`;
